/*
Copyright (C) 2009 - 2019 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

const defaultClassName =
  'tw-w-full tw-py-4 tw-px-3 md:tw-py-2 tw-bg-white hover:tw-bg-gray-100 focus:tw-bg-gray-100 active:tw-bg-gray-200 tw-text-gray-700 hover:tw-text-gray-900 focus:tw-text-gray-900 tw-border-t tw-border-gray-300 focus:tw-outline-none tw-text-center tw-font-medium tw-text-lg md:tw-text-sm tw-whitespace-no-wrap tw-truncate';

const SecondaryAction = ({
  children,
  className,
  disabled,
  onClick,
  ...buttonProps
}) => {
  return (
    <button
      className={cx(className, defaultClassName, {
        'tw-cursor-not-allowed': disabled
      })}
      disabled={disabled}
      onClick={!disabled ? onClick : undefined}
      type="button"
      {...buttonProps}
    >
      {children}
    </button>
  );
};

SecondaryAction.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func
};

export default SecondaryAction;
